/** Четыре темы (неон отменён заказчиком 27.07.2026). dark — по умолчанию. */
export const THEMES = [
  { id: 'dark', title: 'Тёмная', swatch: 'linear-gradient(135deg,#2c3440 50%,#1e242c 50%)' },
  { id: 'wood', title: 'Классика', swatch: 'linear-gradient(135deg,#d9b382 50%,#6b4429 50%)' },
  { id: 'green', title: 'Зелёная', swatch: 'linear-gradient(135deg,#eeeed2 50%,#769656 50%)' },
  { id: 'paper', title: 'Бумага', swatch: 'linear-gradient(135deg,#f6f1e4 50%,#dfd3ba 50%)' },
] as const;

export type ThemeId = (typeof THEMES)[number]['id'];

const KEY = 'bc:theme';

export function currentTheme(): ThemeId {
  const saved = localStorage.getItem(KEY);
  return (THEMES.some((t) => t.id === saved) ? saved : 'dark') as ThemeId;
}

export function applyTheme(id: ThemeId): void {
  document.documentElement.dataset.t = id;
  localStorage.setItem(KEY, id);
}

export function initTheme(): void {
  document.documentElement.dataset.t = currentTheme();
}
